import { render, staticRenderFns } from "./LabelGenCreate.vue?vue&type=template&id=2c84496a"
import script from "./LabelGenCreate.vue?vue&type=script&lang=js"
export * from "./LabelGenCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c84496a')) {
      api.createRecord('2c84496a', component.options)
    } else {
      api.reload('2c84496a', component.options)
    }
    module.hot.accept("./LabelGenCreate.vue?vue&type=template&id=2c84496a", function () {
      api.rerender('2c84496a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelGen/LabelGenCreate.vue"
export default component.exports